import { Box } from 'theme-ui';

const Screen = (props: any) => {
  const children = props.children;
  return <Box>{children}</Box>;
};

export default Screen;
